import {useEffect, useState} from "react"
import LocationCategoryForm, {CategoryInput} from "pages/admin/category/form/LocationCategoryForm"
import {Category, CategoryLevel} from "dto/category/category"
import {useFindAllCategories, useRegisterCategoryMutation} from "hooks/queries/category.query"
import {AxiosError} from "axios"
import CategoryItem from "pages/admin/category/CategoryItem"
import RegisterCategory from "pages/admin/category/RegisterCategory"
import UpdateCategory from "pages/admin/category/UpdateCategory"

export default function LocationCategory() {
    const registerCategory = useRegisterCategoryMutation()
    const data = useFindAllCategories()

    const [showForm, setShowForm] = useState<"register" | "update" | undefined>(undefined)
    const [registerLevel, setRegisterLevel] = useState<CategoryLevel>("CITY")
    const [selectedRootCategory, setSelectedRootCategory] = useState<Category | undefined>(undefined)
    const [selectedSubCategory, setSelectedSubCategory] = useState<Category | undefined>(undefined)
    const [selectedCategory, setSelectedCategory] = useState<Category | undefined>(undefined)
    const [allCategories, setAllCategories] = useState<Category[]>([])
    const [rootCategories, setRootCategories] = useState<Category[]>([])
    const [subCategories, setSubCategories] = useState<Category[]>([])

    useEffect(() => {
        if (data.data) {
            setAllCategories(data.data)
            const rootCtg = data.data.filter((ctg: Category) => ctg.level === "CITY")
            setRootCategories(rootCtg)
        }
        console.log("ctg data: ", data.data)
    }, [data.data])
    useEffect(() => {
        if (!selectedRootCategory) return setSubCategories([])
        const subCtg = allCategories.filter(ctg => ctg.parentId === selectedRootCategory?.id)
        console.log('sub ctg: ', subCtg)
        setSubCategories(subCtg)
    }, [selectedRootCategory, rootCategories])
    const close = () => {
        setShowForm(undefined)
    }
    const onSubmit = (level: CategoryLevel) => {
        return (value: CategoryInput) => {
            const category: Category = {
                name: value.name,
                level,
                parentId: level === "DISTRICT" ? selectedRootCategory?.id : undefined,
            }
            registerCategory.mutate(category, {
                onSuccess: (data, variables, context) => {
                    console.log("success value : ", data, variables, context)
                    close()
                },
                onError: (err, variables, context) => {
                    const error = (err as AxiosError)
                    console.log("error value : ", error, variables, context)
                },
            })
            console.log("category form data : ", value)
        }
    }
    return (
        <div className="admin-container">
            <div className="level ">
                <div className="level-left">
                    <h5 className="is-size-3 has-text-weight-bold">카테고리 관리</h5>
                </div>
                <div className="level-right">
                </div>
            </div>
            <div className="admin-panel admin-body ">
                <section className="is-flex">
                    <div className="is-flex-grow-1 m-4">
                        <nav className="panel is-relative" style={{minHeight: 500, overflowY: 'auto'}}>
                            <div className="panel-heading">
                                상위 카테고리
                            </div>
                            <button className="is-info button is-small is-rounded" style={{
                                position: "absolute",
                                top: 10, right: 10
                            }} onClick={() => {
                                setRegisterLevel("CITY")
                                setShowForm("register")
                            }}>
                                상위 카테고리 추가
                            </button>
                            {rootCategories.map((ctg: Category, idx) => {
                                return (
                                    <CategoryItem
                                        category={ctg} selected={selectedRootCategory === ctg}
                                        key={ctg.id}
                                        isRoot={true}
                                        onSelect={() => {
                                            setSelectedRootCategory(ctg)
                                            setSelectedSubCategory(undefined)
                                        }}
                                        onEdit={(e) => {
                                            e.preventDefault()
                                            e.stopPropagation()
                                            setSelectedCategory(ctg)
                                            setShowForm("update")
                                        }}
                                    />
                                )
                            })}
                        </nav>
                    </div>
                    <div className="is-flex-grow-1 m-4">
                        <nav className="panel is-relative" style={{minHeight: 500, overflowY: 'auto'}}>
                            <p className="panel-heading">
                                하위 카테고리
                            </p>
                            <button className="is-success button is-small is-rounded" style={{
                                position: "absolute",
                                top: 10, right: 10
                            }} onClick={() => {
                                if (!selectedRootCategory) {
                                    alert("상위 카테고리를 선택해주세요.")
                                    return
                                }
                                setRegisterLevel("DISTRICT")
                                setShowForm("register")
                            }}>
                                하위 카테고리 추가
                            </button>
                            {!subCategories || subCategories.length === 0 &&
                                <CategoryItem category={{name: "하위 카테고리가 없습니다.", level: "DISTRICT"}}
                                              onSelect={() => {
                                              }}
                                              onEdit={() => {
                                              }}
                                              selected={false}/>
                            }
                            {subCategories.map((ctg: Category, idx) => {
                                return (
                                    <CategoryItem
                                        category={ctg} selected={selectedSubCategory === ctg}
                                        onSelect={() => {
                                            setSelectedSubCategory(ctg)
                                        }} key={ctg.id}
                                        onEdit={(e) => {
                                            e.preventDefault()
                                            e.stopPropagation()
                                            setSelectedCategory(ctg)
                                            setShowForm("update")
                                        }}
                                    />
                                )
                            })}
                            {/*<div className="panel-block pd20">*/}
                            {/*    <div className="is-flex">*/}
                            {/*        <span className="panel-icon has-text-success">*/}
                            {/*            <i className="fa fa-folder-plus" aria-hidden="true"/>*/}
                            {/*        </span>*/}
                            {/*        <p className="is-size-6 is-bold">카테고리명</p>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        </nav>
                    </div>
                </section>
            </div>
            {showForm === "register" &&
                <RegisterCategory level={registerLevel} selectedCategory={selectedRootCategory}
                                  close={() => setShowForm(undefined)}
                />
                // <LocationCategoryForm show={true} close={() => setShowForm(undefined)}
                //                       onSubmit={onSubmit(registerLevel)}/>
            }
            {showForm === "update" &&
                <UpdateCategory category={selectedCategory} close={() => setShowForm(undefined)}/>
            }
        </div>
    )
}